import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_m84sdvbj3h: FaireBrandEntity = {
  token: "b_m84sdvbj3h",
  type: "brand",
  name: "AEMI + CO",
  avatarUrl:
    "https://cdn.faire.com/fastly/c9b7adb4d42b8234401cd1f37e4c0e1b13b67be31ccab12fb839692d9b3127de.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2649aa84aadfe6e62f571763ee48968c2680e9914aea50a69c35cbdabd0dc36b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c9b7adb4d42b8234401cd1f37e4c0e1b13b67be31ccab12fb839692d9b3127de.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2649aa84aadfe6e62f571763ee48968c2680e9914aea50a69c35cbdabd0dc36b.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 441,
  isTopShop: true,
  isInsider: true,
  description:
    "We live, breathe and dream of curating the perfect outfit with you in focus. Aemi + Co is a fashion brand specializing in contemporary ready-to-wear women's clothing with a clear vision: to provide the latest in compelling designs for the fashionably hip along with providing exceptional value, quality and timeless pieces. Our ultimate goal is to empower women of all backgrounds to feel, see and express their individuality through fashion.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:09.054Z",
    importedBy: "entity-db-cli",
  },
};
